/* eslint-disable */
if (['plum-energie.fr', 'espace-client.plum.fr'].indexOf(location.hostname) > -1) {
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq = function () {
        n.callMethod ?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
        document,'script','https://connect.facebook.net/en_US/fbevents.js');

    // Facebook multipixels https://developers.facebook.com/docs/facebook-pixel/events-advanced-use-cases/v2.12#multipixels
    fbq('init', '300876676956174'); // Plum Facebook Pixel
    fbq('init', '1395294264077293'); // Selectra Facebook Pixel
    fbq('track', 'PageView');
}



// WEBPACK FOOTER //
// ./src/assets/script/facebook-pixel.js